import { render, staticRenderFns } from "./InpatientTables.vue?vue&type=template&id=f99a59c8&scoped=true&"
import script from "./InpatientTables.vue?vue&type=script&lang=js&"
export * from "./InpatientTables.vue?vue&type=script&lang=js&"
import style0 from "./InpatientTables.vue?vue&type=style&index=0&id=f99a59c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99a59c8",
  null
  
)

export default component.exports